import React, { useRef, useState, useEffect } from 'react';
import classNames from 'classnames';
import { Icon as Icon$1 } from '@nearpod-packages/base-library';
import { useCustomTranslation } from '../../Hooks/useCustomTranslation/useCustomTranslation.js';
import styles from './ActivityCard.scss.js';
import Label from './Label/Label.js';
import Tooltip from '../../Tooltip/Tooltip/Tooltip.js';
import Icon from '../../../Icons/Icons/Icon/Icon.js';

const ActivityCard = _ref => {
  let {
    title,
    description = '',
    isSelected = false,
    onClick = () => {},
    label = '',
    isFluid = false,
    icon,
    tabIndex = 0,
    hasAi = false,
    isGoldActivity = false
  } = _ref;
  const descriptionRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);
  const {
    tCustom
  } = useCustomTranslation();
  useEffect(() => {
    const checkTruncation = element => {
      if (element) {
        return element.scrollHeight > element.clientHeight;
      }
      return false;
    };
    setIsTruncated(checkTruncation(descriptionRef.current));
    // We need to wait for the description to arrive as it may take some time for the translation to be done.
  }, [description]);
  return /*#__PURE__*/React.createElement("div", {
    onClick: onClick,
    role: "button",
    tabIndex: tabIndex,
    className: classNames(styles.base, {
      [styles['base--selected']]: isSelected,
      [styles['base--fluid']]: isFluid
    })
  }, !!icon && /*#__PURE__*/React.createElement("div", {
    className: styles['image-container']
  }, label.length > 0 && !hasAi && !isGoldActivity && /*#__PURE__*/React.createElement("div", {
    className: styles.tag
  }, /*#__PURE__*/React.createElement(Label, {
    text: label
  })), hasAi && /*#__PURE__*/React.createElement("div", {
    className: styles.decorator
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.decorator__text
  }, tCustom('AI_ICON_TOOLTIP')), /*#__PURE__*/React.createElement("div", {
    className: styles.decorator__icon
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "ai-builder-stars-default-xs"
  }))), icon), isGoldActivity && /*#__PURE__*/React.createElement("div", {
    className: styles['gold-tooltip']
  }, /*#__PURE__*/React.createElement("p", {
    className: styles['gold-tooltip__text']
  }, tCustom('GOLD_ACTIVITY'))), /*#__PURE__*/React.createElement("div", {
    className: styles['text-container']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['title-wrapper']
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, title), isGoldActivity && /*#__PURE__*/React.createElement("span", {
    className: styles['gold-icon']
  }, /*#__PURE__*/React.createElement(Icon$1, {
    name: "Star",
    color: "npColorYellow70",
    isFilled: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.description,
    ref: descriptionRef
  }, description), isTruncated && /*#__PURE__*/React.createElement("div", {
    className: styles.tooltip
  }, /*#__PURE__*/React.createElement(Tooltip, {
    arrow: "top-center"
  }, description))));
};
var ActivityCard$1 = ActivityCard;

export { ActivityCard$1 as default };
//# sourceMappingURL=ActivityCard.js.map
